export const typography = {
  body1: {
    fontSize: 12,
    lineHeight: 1.3,
  },
  body2: {
    fontSize: 14,
    lineHeight: 1.4,
  },
  body3: {
    fontSize: 16,
    lineHeight: 1.5,
  },
  heading1: {
    fontSize: 14,
    lineHeight: 1.4,
  },
  heading2: {
    fontSize: 16,
    lineHeight: 1.5,
  },
  heading3: {
    fontSize: 20,
    lineHeight: 1.6,
  },
  label: {
    fontSize: 12,
    lineHeight: 1.3,
  },
  helperText: {
    fontSize: 12,
    lineHeight: 1.3,
  },
  input: {
    fontSize: 14,
    lineHeight: 1.4,
    '@media (max-width: 768px)': {
      fontSize: 16,
    },
  },
}
